// extracted by mini-css-extract-plugin
export var displayNone = "_on-6";
export var imgContainer = "_on-2";
export var overflowHidden = "_on-3";
export var productInfoCardButtonContainer = "_on-5";
export var productTitleText = "_on-4";
export var rightArrow = "_on-1";
export var rightArrowContainer = "_on-0";